export default function useDeviceHelpers() {
  const isMobile = () => {
    const userAgent = navigator.userAgent.toLowerCase();

    return userAgent.includes('mobile') || userAgent.includes('android');
  };

  return { isMobile };
}
